import { Injectable } from '@angular/core';
import { MongoService } from './mongo.service';

@Injectable({
  providedIn: 'root'
})
export class ScoringService {

  constructor(
    private mongoService: MongoService
  ) { }

  // Brak cache: jedno współdzielone pole dla obu kampanii groziło zwróceniem
  // scoringu niewłaściwej kampanii. Zawsze pobieramy świeże dane.
  public async getAllPumpsExistingScores() : Promise<Array<any>> {
    return await this.fetchPumpsScores();
  }

  public async clearPumpsScoringData() : Promise<void> {
    const scoringData = await this.getAllPumpsExistingScores();
    if (scoringData?.length > 0) {
      await this.mongoService.deletePumpsScoringData();
    }
  }

  public async addPumpsScoringToStorage(scoringData: Array<any>) : Promise<number> {
    let result: number = 0;
    for (let i = 0; i < scoringData.length; i++) {
      if (await this.addSinglePumpScoreToStorage(scoringData[i])) {
        result++;
      }
    }
    return result;
  }

  private async fetchPumpsScores() : Promise<Array<any>> {
    try {
      let data = await this.mongoService.getAllPumpsScoresData();
      const scores: Array<any> = [];
      data.forEach((d:any) => {
        const data = d;
        scores.push(data);
      });
      return scores;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  private async addSinglePumpScoreToStorage(score: any): Promise<boolean> {
    try {
      await this.mongoService.addPumpsScore(score);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  public async getAllAirconditionersExistingScores() : Promise<Array<any>> {
    return await this.fetchAirconditionersScores();
  }

  public async clearAirconditionersScoringData() : Promise<void> {
    const scoringData = await this.getAllAirconditionersExistingScores();
    if (scoringData?.length > 0) {
      await this.mongoService.deleteAirconditionersScoringData();
    }
  }

  public async addAirconditionersScoringToStorage(scoringData: Array<any>) : Promise<number> {
    let result: number = 0;
    for (let i = 0; i < scoringData.length; i++) {
      if (await this.addSingleAirconditionerScoreToStorage(scoringData[i])) {
        result++;
      }
    }
    return result;
  }

  private async fetchAirconditionersScores() : Promise<Array<any>> {
    try {
      let data = await this.mongoService.getAllAirconditionersScoresData();
      const scores: Array<any> = [];
      data.forEach((d:any) => {
        const data = d;
        scores.push(data);
      });
      return scores;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  private async addSingleAirconditionerScoreToStorage(score: any): Promise<boolean> {
    try {
      await this.mongoService.addAirconditionersScore(score);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
